import axios from 'axios';
import store from '@/store';
import router from '@/router';

const api = axios.create({
  baseURL: `${window.location.origin.replace('8080', '3000')}/api`
});

/**
 * REQUEST INTERCEPTOR
 * Injeta token automaticamente
 */
api.interceptors.request.use(
  config => {
    const token = store.state.auth.token;
    const viewType = store.state.view.viewType;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['x-view-type'] = viewType;

    return config;
  },
  error => Promise.reject(error)
);

/**
 * RESPONSE INTERCEPTOR
 * Trata erros globais
 */
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.dispatch('auth/logout');
      router.push('/login');
    }
    return Promise.reject(error);
  }
);



export default api;
